import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const TEMPLATE_MAX_LENGTH = 32 * 1024;
export enum ContentType {
  HTML = "html-template",
  PlainText = "plain-text-template",
}

export enum TabMode {
  Edit = "edit",
  Preview = "preview",
}
export const DEFAULT_LOGO_URL = "https://cdn.helpdesk-static.com/mailing/logo.png";
export const TAB_MODES: TabMode[] = [TabMode.Edit, TabMode.Preview];
export const TAB_LABELS: string[] = ["Edit", "Preview"];
export const VARIABLE_ICON_CUSTOM_COLOR = withVar(DesignToken.ContentBasicPurple);
